import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
  HttpParams,
} from '@angular/common/http';
import {
  RegulationFilterModel,
  RegulationViewModel,
  RegulationActionFilterModel,
  RegulationActionDetailCollection,
  MasterRegulationActionFilter,
  RegulationActionDetail,
  RegulationModel,
} from '../../models/regulation';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { UserProfile } from '../../models/user';
import { MasterFilterModel } from '../../models/regulation';
import { AlertDialogModel } from 'src/app/core/models/view-model';
import { environment } from '../../../../environments/environment';
import { LibraryType } from './../../enums/regulator/regulator-status';
import { ItemArraryModel } from '../../models/filter-model/item-id-model';
import { BulkCloseModel } from './../../models/regulation/bulk-close-model';
import { LibraryDataModel } from '../../models/view-model/library-data-model';
import { ChangeViewerLibrary } from '../../models/regulation/change-viewer-library';
import { SiblingRulebookModel } from './../../models/rulebook/sibling-rulebook-model';
import { LinkedRegulationInfo } from '../../models/regulation/linked-regulation-info';
import { UserRegulatorFilter } from './../../models/filter-model/user-regulator-filter';
import { RegulationDetailModel } from '../../models/regulation/regulation-detail-model';
import { FilterItemListModel } from './../../models/filter-model/filter-item-list-model';
import { SimilarRegulationFilter } from '../../models/regulation/similar-regulation-filter';
import { SimilarRegulationDataModel } from '../../models/regulation/similar-regulation-model';
import { DynamicRegulationLibrary } from '../../models/regulation/dynamic-regulation-library';
import { PublishRegulationFilter, PublishReportResponse } from 'src/app/core/models/regulation/publish-regulation-model';
import {
  RegulationDetail,
  RegulationDetailDto,
} from '../../models/regulation/regulation-detail';
import {
  StaticLibraryViewModel,
  StaticRegulationLibrary,
} from '../../models/regulation/static-regulation-library';
import { FileType } from '../../enums/user/file-type';
import { SelfAssessmentDocumentModel } from '../../models/self-assessment/self-assessment-document-model';
import { RegulationColumnModel } from '../../models/regulation/regulation-close-status-model';
import { CloseEvidanceDocumentModel } from '../../models/regulation/close-Evidance-document-model';
import {
  bulkcloseEvidanceInputModel,
  closeEvidanceInputModel,
} from '../../models/regulation/close-evidance-input-model';
import { SingleImportUpdateModel } from '../../models/manualUpdates/single-import';
import { GroupingModel } from '../../models/regulation/regulation-filter.model';
import {
  GroupingRegulationViewModel,
  RegulationDescription,
  RegulationWrapper,
} from '../../models/regulation/regulation.model';
import { RegulationStatusInfoT4Model } from '../../models/regulation/regulation-status-infoT4-model';
import { bulkCloseReturnModel } from '../../models/impact-assessment/bulk-close-return-model';
import {
  LinkedAppliesAcrossModel,
  LinkedConnectionModel,
  OwnerCommentModel,
} from '../../models/rulebook/linked-connection-model';
import {
  LinkedAppliesAcrossIdModel,
  LinkedConnectionIdModel,
} from '../../models/regulation/linked-connectionId-model';
import { LinkedConnectionListViewModel } from '../../models/rulebook/linked-connection-list-view-model';
import { FilterViewModelForOwner } from '../../models/regulation/filter-view.model';
import { BrifRulebookFilterModel, RulebookFilterModel } from '../../models/rulebook/rulebook-filters-model';
import { VersionHistoryFilter } from '../../models/self-assessment/version-history-filter';
import { RuleVersionHistoryModel, VersionRegulationModel } from '../../models/regulation/version-history-model';
import { ConfirmSelfAssessedModel } from '../../models/rulebook/confirm-self-assessed-model';
import { RegulationStatusInfoT5Model } from '../../models/impact-assessment/impact-assessmentT5';
import { updateRulebookModel } from '../../models/rulebook/updateRulebookDescription';
import { translateOthersToEnglishInputModel } from '../../models/translate/translateInputModel';
import { GetMatchPoliciesInputModel, MatchPoliciesModel, PolicyMappingCombinationModel, mappingPolicyModel, policyMappingData } from '../../models/regulation/policy-Mapping-model';

@Injectable({ providedIn: 'root' })
export class RegulationService {
  loggedInUser: UserProfile | undefined;
  regulationLibrary!: Array<ChangeViewerLibrary>;
  isShowErrorMessage: boolean = false;

  constructor(private http: HttpClient) {}

  getRegulations(
    regulationFilter: RegulationFilterModel | null,
    pannelName?: string,
    groupBy?: string | GroupingModel,
    clickFilter?: string | undefined
  ): Observable<RegulationViewModel> {
    let headers = new HttpHeaders();
    // grouping filters
    let groupingFilter: RegulationFilterModel;
    groupingFilter = JSON.parse(JSON.stringify(regulationFilter));
    if (pannelName) {
      if (groupBy === 'PubType') {
        groupingFilter.Filters.PubType = [pannelName];
      }
      if (groupBy === 'Country') {
        groupingFilter.Country = [pannelName];
      }
      if (groupBy === 'MappingId') {
        groupingFilter.MappingID = [pannelName];
      }
    }
    if (clickFilter) {
      groupBy === 'MappingId'
        ? (groupingFilter.Filters.PubType = [clickFilter])
        : (groupingFilter.MappingID = [clickFilter]);
    }

    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(groupingFilter));
    // tslint:disable-next-line:max-line-length
    return this.http.get<RegulationViewModel>(
      `${environment.config.baseAppURL}/RegulationManagement/GetRegulatorUpdates`,
      { headers }
    );
  }

  GetGroupRegulatorUpdates(groupingFilter: GroupingModel | null) {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(groupingFilter));
    // tslint:disable-next-line:max-line-length
    return this.http.get<GroupingRegulationViewModel[]>(
      `${environment.config.baseAppURL}/RegulationManagement/GetGroupRegulatorUpdates`,
      { headers }
    );
  }

  getRegulation(
    libraryId: number,
    regulationId: number
  ): Observable<RegulationModel> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', libraryId + ';' + regulationId);

    // tslint:disable-next-line:max-line-length
    return this.http.get<RegulationModel>(
      `${environment.config.baseAppURL}/RegulationManagement/GetRegulatorUpdate`,
      { headers }
    );
  }

  getMasterFilters(): Observable<MasterFilterModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<MasterFilterModel>(
      `${environment.config.baseAppURL}/RegulationManagement/GetMasterFilterList`,
      { headers }
    );
  }

  downloadRegulations(regulationFilter: RegulationFilterModel | null): any {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(regulationFilter));
    // tslint:disable-next-line:max-line-length
    return this.http.get(
      `${environment.config.baseAppURL}/RegulationManagement/ExportRegulationsToExcel`,
      { headers, responseType: 'blob' }
    );
  }

  getMasterRegulationActionFilters(): Observable<MasterRegulationActionFilter> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<MasterRegulationActionFilter>(
      `${environment.config.baseAppURL}/UserRegulationManagement/GetMasterRegulationActionFilters`,
      { headers }
    );
  }

  getRegulationActionManagements(
    regulationFilter: RegulationActionFilterModel | null
  ): Observable<RegulationActionDetailCollection> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(regulationFilter));
    // tslint:disable-next-line:max-line-length
    return this.http.get<RegulationActionDetailCollection>(
      `${environment.config.baseAppURL}/UserRegulationManagement/GetRegulationActionDetails`,
      { headers }
    );
  }

  getActionDetail(id: number): Observable<RegulationActionDetail> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(id));
    // tslint:disable-next-line:max-line-length
    return this.http.get<RegulationActionDetail>(
      `${environment.config.baseAppURL}/UserRegulationManagement/GetRegulationActionDetail`,
      { headers }
    );
  }

  saveRegulationActionDetail(
    regAction: RegulationActionDetail
  ): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    // tslint:disable-next-line:max-line-length
    return this.http
      .post<any>(
        `${environment.config.baseAppURL}/UserRegulationManagement/SaveRegulationActionDetail`,
        regAction,
        httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  deleteRegulationAction(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(id));
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(
      `${environment.config.baseAppURL}/UserRegulationManagement/DeleteRegulationActionDetail`,
      { headers }
    );
  }

  handleError(error: HttpErrorResponse): any {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened; please try again later.');
  }

  getPublishedDate(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(
      `${environment.config.baseAppURL}/RegulationManagement/GetLatestDate`,
      { headers }
    );
  }

  getUserFilters(): Observable<UserRegulatorFilter[]> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<UserRegulatorFilter[]>(
      `${environment.config.baseAppURL}/RegulationManagement/GetUserFilters`,
      { headers }
    );
  }

  saveFilters(filtersData: UserRegulatorFilter): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filtersData));
    return this.http.get<any>(
      `${environment.config.baseAppURL}/RegulationManagement/SaveUserFilters`,
      { headers }
    );
  }

  removeUserFilters(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/RegulationManagement/DeleteUserFilters?id=` +
        id,
      { headers }
    );
  }

  moveToSelfAssessment(regulation: RegulationModel,screenUrl: string, divisionId:number): Observable<any> {
    let wrapper = new RegulationWrapper();
    wrapper.regulationData = regulation;
    wrapper.screenUrl = screenUrl;
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(
      `${environment.config.baseAppURL}/RegulationManagement/MoveToSelfAssessment?divisionId=`+divisionId, wrapper);
  }

  updateRegulationInfo(regulationInfo: RegulationDetail): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(
      `${environment.config.baseAppURL}/RegulationManagement/UpdateRegulationDetail`,
      {
        RegulationDetail: regulationInfo,
        RegulatorId: regulationInfo.regulatorId,
        Regulator: regulationInfo.regulator,
      },
      { headers }
    );
  }

  moveToRegulationDetail(regulationInfo: RegulationDetailDto): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(
      `${environment.config.baseAppURL}/RegulationManagement/MoveToRegulationDetail`,
      regulationInfo,
      { headers }
    );
  }

  regulationBulkClose(bulkData: BulkCloseModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(bulkData));
    return this.http.get<any>(
      `${environment.config.baseAppURL}/RegulationManagement/UpdateBulkRegulationDetail`,
      { headers }
    );
  }

  getLinkedUpdates(
    regulationFilter: RegulationFilterModel | null
  ): Observable<RegulationViewModel> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(regulationFilter));
    return this.http.get<RegulationViewModel>(
      `${environment.config.baseAppURL}/RegulationManagement/GetLinkedUpdates`,
      { headers }
    );
  }

  getSiblings(id: number,filter: RulebookFilterModel): Observable<number[]> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
    .set('request', JSON.stringify(filter));
    return this.http.get<number[]>(
      `${environment.config.baseAppURL}/RegulationManagement/GetSiblingIds?id=` +
        id,
      { headers }
    );
  }
  getRuleSiblings(id: number,filter: RulebookFilterModel): Observable<number[]> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
    .set('request', JSON.stringify(filter));
    return this.http.get<number[]>(
      `${environment.config.baseAppURL}/RegulationManagement/GetSiblingRuleIds?id=` +
        id,
      { headers }
    );
  }

  downloadIAReport(regulationFilter: RegulationFilterModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(regulationFilter));
    return this.http.get(
      `${environment.config.baseAppURL}/RegulationManagement/DownloadReport`,
      { headers, responseType: 'blob' }
    );
  }

  saveToMyLibrary(obj: LibraryDataModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(
      `${environment.config.baseAppURL}/RegulationManagement/AddToLibrary`,
      obj,
      { headers }
    );
  }

  getRegulationLibrary(sortKey: string, isDesc: boolean): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/RegulationManagement/GetRegulationLibrary?sortKey=` +
        sortKey +
        '&isDesc=' +
        isDesc,
      { headers }
    );
  }

  getUserRegulationLibrary(type: LibraryType): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/RegulationManagement/GetUserRegulationLibrary?type=` +
        type,
      { headers }
    );
  }

  getLibraryFilterJson(
    libraryId: number
  ): Observable<DynamicRegulationLibrary> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<DynamicRegulationLibrary>(
      `${environment.config.baseAppURL}/RegulationManagement/GetDynamicLibraryData?id=` +
        libraryId,
      { headers }
    );
  }

  removeRegulationLibrary(libraryId: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/RegulationManagement/DeleteRegulationLibrary?id=` +
        libraryId,
      { headers }
    );
  }

  shareRegulationLibrary(dataObj: FilterItemListModel, userDivision:string | null): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(dataObj));
    return this.http.get<any>(
      `${environment.config.baseAppURL}/RegulationManagement/ShareRegulationLibrary?userDivision=`+userDivision,
      { headers }
    );
  }

  getStaticLibraryInfo(
    id: number,
    libraryId: number
  ): Observable<StaticRegulationLibrary> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<StaticRegulationLibrary>(
      `${environment.config.baseAppURL}/RegulationManagement/GetStaticLibraryInfo?id=` +
        id +
        '&libraryId=' +
        libraryId,
      { headers }
    );
  }

  updateStaticLibraryInfo(
    obj: StaticLibraryViewModel
  ): Observable<StaticRegulationLibrary> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<StaticRegulationLibrary>(
      `${environment.config.baseAppURL}/RegulationManagement/UpdateStaticLibraryInfo`,
      obj,
      { headers }
    );
  }

  removeLinkedUpdates(ids: number[]): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(ids));
    return this.http.get<any>(
      `${environment.config.baseAppURL}/RegulationManagement/DeleteLinkedUpdates`,
      { headers }
    );
  }

  removeStaticLibraryitem(deletedItems: ItemArraryModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(deletedItems));
    return this.http.get<any>(
      `${environment.config.baseAppURL}/RegulationManagement/DeleteStaticLibraryItems`,
      { headers }
    );
  }

  getCurrentActions(itemId: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/RegulationManagement/GetOtherJurisdictionClosedRegulation?id=` +
        itemId,
      { headers }
    );
  }

  deleteClosedRegulation(
    id: number,
    regId: number,
    jurisdiction: string
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    const encodedSyntax = encodeURIComponent(jurisdiction);
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(
      `${environment.config.baseAppURL}/RegulationManagement/DeleteRegulationDetails?id=` +
        id +
        '&regulationId=' +
        regId +
        `&jurisdiction=` +
        encodedSyntax,
      { headers }
    );
  }

  getSimilarRegulation(
    filterObj: SimilarRegulationFilter
  ): Observable<SimilarRegulationDataModel> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filterObj));
    return this.http.get<SimilarRegulationDataModel>(
      `${environment.config.baseAppURL}/RegulationManagement/GetSimilarRegulations`,
      { headers }
    );
  }

  getLinkedInfo(
    id: number,
    selectedJuris: string
  ): Observable<LinkedRegulationInfo> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<LinkedRegulationInfo>(
      `${environment.config.baseAppURL}/RegulationManagement/GetLinkedInfo?id=` +
        id +
        `&selectedJuris=` +
        selectedJuris,
      { headers }
    );
  }

  getPublishReport(regulationFilter: PublishRegulationFilter): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(regulationFilter));
    return this.http.get<any>(
      `${environment.config.baseAppURL}/RegulationManagement/GetPublishReport`,
      { headers }
    );
  }

  updateLibraryInfo(obj: AlertDialogModel): Observable<ChangeViewerLibrary> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<ChangeViewerLibrary>(
      `${environment.config.baseAppURL}/RegulationManagement/UpdateLibraryInfo?id=` +
        obj.Id +
        '&libraryName=' +
        obj.BodyInput,
      { headers }
    );
  }

  updateLibraryOrder(
    id: number,
    current: number
  ): Observable<ChangeViewerLibrary[]> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<ChangeViewerLibrary[]>(
      `${environment.config.baseAppURL}/RegulationManagement/UpdateLibraryOrder?id=` +
        id +
        '&current=' +
        current,
      { headers }
    );
  }

  getRegulationDetails(
    id: number,
    jurisdiction: string
  ): Observable<RegulationDetail> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<RegulationDetail>(
      `${environment.config.baseAppURL}/RegulationManagement/GetRegulationDetail?id=` +
        id +
        `&jurisdiction=` +
        jurisdiction,
      { headers }
    );
  }
  uploadEvidence(
    fileToUpload: File,
    fileType: FileType,
    assessmentId: number,
    juridiction: string
  ): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    let headers = new HttpHeaders();
    headers = headers.set(
      'request',
      fileType.toString() +
        ';' +
        assessmentId.toString() +
        ';' +
        juridiction.toString()
    );
    return this.http.post<any>(
      `${environment.config.baseAppURL}/RegulationManagement/UploadEvidenceFile`,
      formData,
      { headers }
    );
  }
  getImpactAssessmentDocuments(
    id: string,
    jurisdiction: string
  ): Observable<Array<CloseEvidanceDocumentModel>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    const encodedSyntax = encodeURIComponent(jurisdiction);
    return this.http.get<Array<CloseEvidanceDocumentModel>>(
      `${environment.config.baseAppURL}/RegulationManagement/GetImpactAssessmentDocument?id=` +
        id +
        `&jurisdiction=` +
        encodedSyntax,
      { headers }
    );
  }
  downloadEvidence(id: number, Regulation: RegulationDetail): Observable<any> {
    const params = new HttpParams().set('p1', 'one!').set('para2', 'two');
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(Regulation));
    return this.http.get(
      `${environment.config.baseAppURL}/RegulationManagement/DownloadEvidence`,
      { headers, responseType: 'blob' }
    );
  }
  DeleteCloseEvidenceDocument(
    id: number,
    closeEvidanceInput: closeEvidanceInputModel
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(closeEvidanceInput));
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(
      `${environment.config.baseAppURL}/RegulationManagement/DeleteRegulationCloseEdivanceDocument?id=` +
        id,
      { headers }
    );
  }
  getRegulationStatus(): Observable<RegulationColumnModel[]> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<RegulationColumnModel[]>(
      `${environment.config.baseAppURL}/RegulationManagement/GetCloseStatusList`,
      { headers }
    );
  }
  uploadEvidenceForBulkClose(
    fileToUpload: File,
    fileType: FileType,
    bulkId: string,
    juridiction: string
  ): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    let headers = new HttpHeaders();
    headers = headers.set(
      'request',
      fileType.toString() +
        ';' +
        bulkId.toString() +
        ';' +
        juridiction.toString()
    );
    return this.http.post<any>(
      `${environment.config.baseAppURL}/RegulationManagement/UploadEvidenceFileForBulkClose`,
      formData,
      { headers }
    );
  }
  DeleteBulkCloseEvidenceDocument(
    id: number,
    closeEvidanceInput: bulkcloseEvidanceInputModel
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(closeEvidanceInput));
    return this.http.get<any>(
      `${environment.config.baseAppURL}/RegulationManagement/DeleteBulkRegulationCloseEdivanceDocument?id=` +
        id,
      { headers }
    );
  }
  // saveRegulationSingleDetail(input: SingleImportUpdateModel): Observable<any> {
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json',
  //     })
  //   };
  //   return this.http.post<any>(`${environment.config.baseAppURL}/RegulationManagement/InsertSingleManualUpdate`, input, httpOptions)

  // }
  saveRegulationSingleDetail(input: SingleImportUpdateModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(
      `${environment.config.baseAppURL}/RegulationManagement/InsertSingleManualUpdate`,
      input,
      { headers }
    );
  }
  getRegulationSingleDetail(id: number): Observable<SingleImportUpdateModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<SingleImportUpdateModel>(
      `${environment.config.baseAppURL}/RegulationManagement/GetUpdateDb?id=` +
        id,
      { headers }
    );
  }
  removeRegulationSingleDetail(
    id: number
  ): Observable<SingleImportUpdateModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/RegulationManagement/DeleteUpdateDb?id=` +
        id,
      { headers }
    );
  }
  ScanAndGetBulkManualUpdate(
    fileToUpload: File,
    juridiction: string
  ): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    let headers = new HttpHeaders();
    headers = headers.set('request', juridiction.toString());
    return this.http.post<any>(
      `${environment.config.baseAppURL}/RegulationManagement/ScanAndGetBulkManualUpdate`,
      formData,
      { headers }
    );
  }

  InserBulkUpDateDb(inputData: any, jurisdictio: any): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(
      `${environment.config.baseAppURL}/RegulationManagement/InsertBulkUpdateDb`,
      { DbList: inputData, JurisdictionId: jurisdictio },
      { headers }
    );
  }

  downloadBulkImportTemplate(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get(
      `${environment.config.baseAppURL}/RegulationManagement/DownloadBulkImportTemplate`,
      { headers, responseType: 'blob' }
    );
  }

  moveBulkImpactAssessmentBulkClose(bulkData: BulkCloseModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(bulkData));
    return this.http.get<any>(
      `${environment.config.baseAppURL}/RegulationManagement/RemoveImpactAssessmentDetail`,
      { headers }
    );
  }

  GetImpactOfRegulation(regulationId: number) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    let queryParams = new HttpParams();
    queryParams = queryParams.append('id', regulationId);
    return this.http.get<any>(
      `${environment.config.baseAppURL}/RegulationManagement/GetImpactOfRegulation`,
      { headers, params: queryParams }
    );
  }

  moveBulkImpactAssessmentT4BulkClose(
    bulkData: BulkCloseModel
  ): Observable<bulkCloseReturnModel> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(bulkData));
    return this.http.get<bulkCloseReturnModel>(
      `${environment.config.baseAppURL}/RegulationManagement/RemoveImpactAssessmentT4Detail`,
      { headers }
    );
  }

  getCurrentActionsT4(
    itemId: number
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/RegulationManagement/GetOtherJurisdictionClosedRegulationT4?id=` +
        itemId,
      { headers }
    );
  }
  getDescription(regulator: string): Observable<RegulationDescription> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<RegulationDescription>(
      `${environment.config.baseAppURL}/RegulationManagement/GetDescription?regulator=` +
        regulator,
      { headers }
    );
  }

  //For Add Remove Connection

  getAddRemoveRulebookDataList(filter:BrifRulebookFilterModel): Observable<LinkedConnectionListViewModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
    .set('request', JSON.stringify(filter));
    return this.http.get<LinkedConnectionListViewModel>(
      `${environment.config.baseAppURL}/RegulationManagement/GetAddRemoveRulebookDataList`,
      { headers }
    );
  }
  saveLinkedConnection(
    linkedConnection: LinkedConnectionModel
  ): Observable<LinkedConnectionModel> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(linkedConnection));
    return this.http.get<LinkedConnectionModel>(
      `${environment.config.baseAppURL}/RegulationManagement/AddLinkedConnection`,
      { headers }
    );
  }
  getLinkedConnectionIds(
    linkedIds: string
  ): Observable<Array<LinkedConnectionIdModel>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Array<LinkedConnectionIdModel>>(
      `${environment.config.baseAppURL}/RegulationManagement/GetLinkedConnectionIds?ids=` +
        linkedIds,
      { headers }
    );
  }
  deleteLinkedConnection(
    linkedConnection: LinkedConnectionModel
  ): Observable<LinkedConnectionModel> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(linkedConnection));
    return this.http.get<LinkedConnectionModel>(
      `${environment.config.baseAppURL}/RegulationManagement/DeleteLinkedConnection`,
      { headers }
    );
  }

  //For Applies Across

  getAppliesAcrossDataList(): Observable<LinkedConnectionListViewModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<LinkedConnectionListViewModel>(
      `${environment.config.baseAppURL}/RegulationManagement/GetAppliesAcrossDataList`,
      { headers }
    );
  }
  saveAppliesAcrossConnection(
    linkedConnection: LinkedAppliesAcrossModel
  ): Observable<LinkedAppliesAcrossModel> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(linkedConnection));
    return this.http.get<LinkedAppliesAcrossModel>(
      `${environment.config.baseAppURL}/RegulationManagement/AddLinkedAppliesAcross`,
      { headers }
    );
  }
  getAppliesAccrossLinkedIds(
    linkedIds: string
  ): Observable<Array<LinkedAppliesAcrossIdModel>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Array<LinkedAppliesAcrossIdModel>>(
      `${environment.config.baseAppURL}/RegulationManagement/GetAppliesAccrossLinkedIds?ids=` +
        linkedIds,
      { headers }
    );
  }
  deleteLinkedAppliesAcrossConnection(
    linkedConnection: LinkedAppliesAcrossModel
  ): Observable<LinkedAppliesAcrossModel> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(linkedConnection));
    return this.http.get<LinkedAppliesAcrossModel>(
      `${environment.config.baseAppURL}/RegulationManagement/DeleteLinkedAppliesAcrossConnection`,
      { headers }
    );
  }

  addUpdateCommentTimeStamp(
    ownerComment: OwnerCommentModel
  ): Observable<OwnerCommentModel> {
    let headers = new HttpHeaders();
    headers = headers
      .set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<OwnerCommentModel>(
      `${environment.config.baseAppURL}/RegulationManagement/AddUpdateCommentTimeStamp`,ownerComment,
      { headers }
    );
  }

  getAllComments(regulationId: number): Observable<string> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<string>(
      `${environment.config.baseAppURL}/RegulationManagement/GetAllCommentsById?regulationId=` +
        regulationId,
      { headers }
    );
  }
  deleteCommentByKeyAndId(
    keyValue: string,
    regulationId: number
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(
      `${environment.config.baseAppURL}/RegulationManagement/DeleteCommentByKeyAndId`,
      { KeyValue: keyValue, RegulationId: regulationId },
      { headers }
    );
  }
  getUserListForOwner(): Observable<Array<FilterViewModelForOwner>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Array<FilterViewModelForOwner>>(
      `${environment.config.baseAppURL}/RegulationManagement/GetUserListForOwner`,
      { headers }
    );
  }
  addUpdateOwner(owner: string, regulationId: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(
      `${environment.config.baseAppURL}/RegulationManagement/AddUpdateOwner`,
      { Owner: owner, RegulationId: regulationId },
      { headers }
    );
  }
  updateComment(ownerComment: OwnerCommentModel, commentKey:string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(
      `${environment.config.baseAppURL}/RegulationManagement/UpdateComment`,
      { OwnerCommentModel: ownerComment, CommentKey: commentKey },
      { headers }
    );
  }
  isSelfAssessed(regulationId:number, divisionId:number):Observable<ConfirmSelfAssessedModel>{
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<ConfirmSelfAssessedModel>(
      `${environment.config.baseAppURL}/RegulationManagement/IsSelfAssessed?regulationId=${regulationId}&divisionId=${divisionId}`,
      { headers }
  );
  }
  getDescriptionById(regulationId: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/RegulationManagement/GetDescriptionById?id=` +
      regulationId,
      { headers }
    );
  }
  getVersionHistory(filter: VersionHistoryFilter): Observable<RuleVersionHistoryModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    return this.http.get<RuleVersionHistoryModel>(`${environment.config.baseAppURL}/RegulationManagement/GetRulebookVersionHistory`, { headers });
  }
  getVersionRulebookByIdForDetail(rulebookId: number): Observable<VersionRegulationModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(rulebookId));
    return this.http.get<VersionRegulationModel>(`${environment.config.baseAppURL}/RegulationManagement/GetVersionRulebookByIdForDetail`, { headers });
  }
  GetRulebookVersionHistoryIds(id:number): Observable<number[]> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<number[]>(`${environment.config.baseAppURL}/RegulationManagement/GetRulebookVersionHistoryIds?id=`+id, { headers });
  }
  // DownloadtPublishReport(publishReport: string, htmlContent: PublishReportResponse): Observable<any> {
  // //DownloadtPublishReport(htmlContent: string, publishReport: PublishReportResponse): Observable<any> {
  //   let headers = new HttpHeaders();
  //   // headers = headers
  //   //   .set('Content-Type', 'application/json; charset=utf-8')
  //   //   .set('request', JSON.stringify(publishReport));
  //   const data = { publishReport };
  //  return this.http.post(
  //   `${environment.config.baseAppURL}/RegulationManagement/DownloadtPublishReport`,data,
  //   { headers, responseType: 'blob' }
  // );
  //   // return this.http.post<any>(
  //   //   `${environment.config.baseAppURL}/RegulationManagement/DownloadtPublishReport`,data
  //   // );
  // }
  getHtmlContent(htmlFilePath: string) {
    return this.http.get(htmlFilePath, { responseType: 'text' });
  }
  DownloadtPublishReport(htmlContent: string): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    const data = { htmlContent};
      return this.http.post(
      `${environment.config.baseAppURL}/RegulationManagement/DownloadtPublishReport`,
      data,
      { headers, responseType: 'blob' }
    );
  }
  getCurrentActionsT5(
    itemId: number
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/RegulationManagement/GetOtherJurisdictionClosedRegulationT5?id=` +
        itemId,
      { headers }
    );
  }
  updateRegulationDescription(rulebookDto: updateRulebookModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(`${environment.config.baseAppURL}/RegulationManagement/UpdateRegulationDescription`, rulebookDto, { headers });
  }

  sendTranslatePostRequest(token: any, data:translateOthersToEnglishInputModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
    return this.http.post<any>(`${environment.config.baseAppURL}/RegulationManagement/GetTranslatedText`, data, { headers });
  }
  GetPolicyMapping(updatedDbId:number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      //.set('request', JSON.stringify(rulebookId));
    return this.http.get<policyMappingData>(`${environment.config.baseAppURL}/RegulationManagement/GetPolicyMapping?updatedDbId=`+updatedDbId, { headers });
  }
  GetPolicyMappingRig(updatedDbId:number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      //.set('request', JSON.stringify(rulebookId));
    return this.http.get<policyMappingData>(`${environment.config.baseAppURL}/RegulationManagement/GetPolicyMappingRig?updatedDbId=`+updatedDbId, { headers });
  }
  UpdatePolicyMapping(policyMappingData:policyMappingData): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      //.set('request', JSON.stringify(rulebookId));
      return this.http.post<any>(`${environment.config.baseAppURL}/RegulationManagement/AddUpdatePolicyMapping`, policyMappingData, { headers });
    //return this.http.get<policyMappingData>(`${environment.config.baseAppURL}/RegulationManagement/GetPolicyMapping?updatedDbId=`+updatedDbId, { headers });
  }
  GetPdfDoc(url:string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      //.set('request', JSON.stringify(rulebookId));
    return this.http.get<policyMappingData>(`${environment.config.baseAppURL}/RegulationManagement/downloadPdf?pdfUrl=`+url, { headers });
  }
  GetPolicies(policyName:string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
    return this.http.get<any>(`${environment.config.baseAppURL}/RegulationManagement/GetPolicies?policyName=`+policyName, { headers });
  }
  getMappedData(matchPoliciesInput: MatchPoliciesModel,combination:PolicyMappingCombinationModel): Observable<mappingPolicyModel[]> {
    let getMatchPoliciesInputModel= new GetMatchPoliciesInputModel();
    getMatchPoliciesInputModel.matchPoliciesModel=matchPoliciesInput;
    getMatchPoliciesInputModel.combination=combination;
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<mappingPolicyModel[]>(`${environment.config.baseAppURL}/RegulationManagement/GetMatchPolicies`, getMatchPoliciesInputModel, { headers });
  }
  GetSimilarityThreshhold(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
    return this.http.get<any>(`${environment.config.baseAppURL}/RegulationManagement/GetSimilarityThreshhold`, { headers });
  }
  saveThreshholdData(value: number) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
    const data = { floatValue: value }; // Assuming value is a floating-point number
    return this.http.post<any>(`${environment.config.baseAppURL}/RegulationManagement/UpdateSimilarityThreshhold`,data, { headers });
  }
  getCurrentActionsT6(
    itemId: number
  ): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/RegulationManagement/GetOtherJurisdictionClosedRegulationT6?id=` +
        itemId,
      { headers }
    );
  }
  getRegulationCurrentActions(itemId: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(
      `${environment.config.baseAppURL}/RegulationManagement/GetRegulationsActionedStatus?id=` +
        itemId,
      { headers }
    );
  }
}
